import { normalizeMessage } from "../word-suggestion";
import { sendOrchestratorRequest } from "./chat-orchestrator-service";

export const preparePrompt = (
  autoGenerated: boolean,
  input: string,
  generatedQuestion: string
) => {
  if (autoGenerated) {
    return generatedQuestion.trim();
  }
  return normalizeMessage(input);
};

export type SendUserPromptResponse = {
  response_id: number;
  response_successful: boolean;
  response_text: string;
};

export const sendUserPrompt = async (
  prompt: string,
  bePrompt: string,
  autoGenerated: boolean,
  functionKey: string,
  chatbotPersonality: string,
  chatLanguage: string,
  username: string
): Promise<SendUserPromptResponse> => {
  const requestBody = {
    user_prompt: {
      user_prompt_fe: prompt,
      user_prompt_be: bePrompt,
    },
    is_auto_gen_question: autoGenerated,
    role_info_mode: chatbotPersonality,
    system_language: chatLanguage,
    user: username,
  };
  const response = await sendOrchestratorRequest(requestBody, functionKey);
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return JSON.parse(await response.text());
};
